import fetchClient from '@/api/api-client'

export const createPaymentLink = async paymentFormData => {
  return await fetchClient.post('/payments/getlink', paymentFormData)
}

export const createPaymentLinkRP = async paymentFormData => {
  return await fetchClient.post('/payments/getlink-returnPackage', paymentFormData)
}

export const refundPayment = async paymentFormData => {
  return await fetchClient.post('/payments/packageRefund', paymentFormData)
}
